export enum CONFIG_FILES {
    FEATURE_FLAGS = '/featureflags.json',
    APP_CONFIG = '/config.json'
}
